/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-lone-blocks */
import { Flex, Space, Typography } from "antd";
import React, { useState } from "react";
import { Colors } from "../helpers";
import { useCallHistoryProvider } from "../context/CallHIstoryContext";
import { useTheme } from "../../../ThemeContext";
import Button from "../../common/button/Button";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { Scrollbar } from "smooth-scrollbar-react";
import { getPatientsCallDataPDF } from "../../../utils/CustomerUiAPI";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, IconButton, Tooltip } from "@mui/material";

const { Text } = Typography;

export const CallSummary = ({ viewMore, setViewMore }) => {
  const { currentTheme, themeMode } = useTheme();
  const { callContent, getSelectedMemberInfo } = useCallHistoryProvider();
  const { copay_verified, white_sheet } = callContent;
  const { member_name, member_id } = getSelectedMemberInfo() || {};

  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);

  const containsPriorApproval = (text) => {
    const priorApprovalTerms = [
      "pre approval",
      "prior approval",
      "pre authorization",
      "prior authorization",
      "pre authorisation",
      "prior authorisation",
      "pre cert",
      "pre certification",
      "pre certified",
      "pre certify",
      "pre-approval",
      "pre-cert",
      "pre-certification",
      "Preauthorization",
      "Predetermination",
      "preauthorization",
      "predetermination",
    ];

    const lowerCaseText = text.toLowerCase();
    // Check if ANY term exists in the text using some
    const containsTerm = priorApprovalTerms.some((term) =>
      lowerCaseText.includes(term)
    );
    return containsTerm;
  };

  const renderIndividualService = (info) => {
    if (info && info.information) {
      return (
        <Flex vertical gap={4}>
          <span style={{ fontWeight: "700" }}>{info.service}</span>
          {info.information.map((item, index) => {
            const key = Object.keys(item)[0];
            const isBold = containsPriorApproval(key);
            return (
              <Flex
                key={index}
                justify="space-between"
                style={{
                  paddingLeft: "2vh",
                  fontWeight: isBold ? "bold" : "normal",
                }}
              >
                <Text
                  style={{
                    color: isBold
                      ? "#ff4e3a"
                      : themeMode === "dark"
                      ? "white"
                      : "black",
                    fontSize: 13,
                    width: "70%",
                  }}
                >
                  {key}
                </Text>
                <Text
                  style={{
                    color: isBold
                      ? "#ff4e3a"
                      : themeMode === "dark"
                      ? "white"
                      : "black",
                    fontSize: 13,
                    width: "30%",
                    marginLeft: "auto",
                  }}
                >
                  {item[key]}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      );
    }
    return null;
  };

  const renderIndividualIVRService = (info) => {
    if (info) {
      return (
        <Flex vertical gap={4} style={{ maxHeight: "46vh" }}>
          <Flex
            justify="space-between"
            style={{
              paddingLeft: "2vh",
            }}
          >
            <Text
              style={{
                color: themeMode === "dark" ? "white" : "black",
                fontSize: 13,
                width: "70%",
              }}
            >
              {Object.keys(info)[0]}
            </Text>
            <Text
              style={{
                color: themeMode === "dark" ? "white" : "black",
                fontSize: 13,
                width: "30%",
                marginLeft: "auto",
              }}
            >
              {Object.values(info)[0]}
            </Text>
          </Flex>
        </Flex>
      );
    }
    return null;
  };
  const toCamelCase = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add a space between camel case words
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2") // Add a space between consecutive capital letters and a capital followed by lowercase
      .replace(/([a-z])([0-9])/g, "$1 $2") // Add a space between letters and digits
      .replace(/([0-9])([a-zA-Z])/g, "$1 $2") // Add a space between digits and letters
      .replace(/\s+/g, " ") // Replace multiple spaces with a single space
      .trim() // Remove leading and trailing spaces
      .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()); // Capitalize first letter of each word
  };

  const convertValuesToCamelCase = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map((item) => convertValuesToCamelCase(item));
    } else if (obj !== null && obj.constructor === Object) {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        acc[key] =
          typeof value === "string"
            ? toCamelCase(value)
            : convertValuesToCamelCase(value);
        return acc;
      }, {});
    }
    return obj;
  };

  const handleDownload = () => {
    let workbook = XLSX.utils.book_new();

    // Create worksheets for each section
    const categoryData = {
      ...white_sheet.Category_Details
    };

    const coverageData = {
      CPT_Code: white_sheet.Coverage_Details.CPT_Code,
      Service_Description: white_sheet.Coverage_Details.Service_Description,
      ...white_sheet.Coverage_Details.Information
    };

    // Add Category Details worksheet
    let categoryWorksheet = XLSX.utils.json_to_sheet([convertValuesToCamelCase(categoryData)]);
    XLSX.utils.book_append_sheet(workbook, categoryWorksheet, 'Category Details');

    // Add Coverage Details worksheet
    let coverageWorksheet = XLSX.utils.json_to_sheet([convertValuesToCamelCase(coverageData)]);
    XLSX.utils.book_append_sheet(workbook, coverageWorksheet, 'Coverage Details');

    XLSX.writeFile(workbook, `CallSummary-${member_id}-${member_name}.xlsx`, {
      compression: true,
    });
  };

  const truncateSheetName = (name) => {
    return name.length > 31 ? name.substring(0, 31) : name;
  };

  const handleDownloadPDF = async () => {
    try {
      const pdfUrlResponse = await getPatientsCallDataPDF(
        sessionStorage.getItem("mail"),
        sessionStorage.getItem("sessionId"),
        callContent.pdf_path
      );

      const pdfUrl = pdfUrlResponse.response; // Access the signed URL from the 'response' field
      const memberId = member_id; // Replace with actual member_id
      const memberName = member_name; // Replace with actual member_name

      const filename = `CallSummary-${memberId}-${memberName}.pdf`;

      // Fetch the PDF file
      const response = await fetch(pdfUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch PDF: ${response.statusText}`);
      }

      // Convert the response to a Blob
      const blob = await response.blob();

      // Create a Blob URL
      const blobUrl = URL.createObjectURL(blob);

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      // Append the anchor element to the document body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Remove the anchor element from the document body
      document.body.removeChild(link);

      // Revoke the Blob URL
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const getContent = () => {
    if (white_sheet) {
      const content = [];
      let refernceNumber = null;
      let effectiveDate = null;
      let terminationDate = null;

      if (white_sheet !== "None") {
        if (white_sheet["Reference Number"] !== null) {
          refernceNumber = Object.values(white_sheet["Reference Number"]);
        } else {
          refernceNumber = "No reference number";
        }

        if (white_sheet["Effective Date"] !== null) {
          effectiveDate = Object.values(white_sheet["Effective Date"]);
        } else {
          effectiveDate = "No effective date";
        }

        if (white_sheet["Termination Date"] !== null) {
          terminationDate = Object.values(white_sheet["Termination Date"]);
        } else {
          terminationDate = "No termination date";
        }
      }

      content.push(
        <div style={{ fontWeight: "bold", marginBottom: "1rem" }}>
          EFFECTIVE DATE: <span>{effectiveDate}</span>
        </div>
      );
      content.push(
        <div style={{ fontWeight: "bold", marginBottom: "1rem" }}>
          TERMIATION DATE: <span>{terminationDate}</span>
        </div>
      );

      {
        white_sheet &&
          white_sheet["Benefits Informations"] &&
          white_sheet["Benefits Informations"].map((info, index) => {
            content.push(
              <div key={index}>{renderIndividualService(info)}</div>
            );
          });
      }

      content.push(
        <div style={{ fontWeight: "bold" }}>
          IVR Given Benefits Informations
        </div>
      );
      {
        white_sheet &&
          white_sheet["IVR Given Benefits Information"] &&
          white_sheet["IVR Given Benefits Information"].map((info, index) => {
            content.push(
              <div key={index}>{renderIndividualIVRService(info)}</div>
            );
          });
      }

      content.push(
        <div style={{ fontWeight: "bold", marginTop: "1rem" }}>
          REFERENCE NUMBER: <span>{refernceNumber}</span>
        </div>
      );

      return <div>{content}</div>;
    }
  };

  const handleCopyToClipboard = () => {
    if (!white_sheet) return;

    let textToCopy = '';

    // Add Category Details
    textToCopy += 'Category Details:\n';
    Object.entries(white_sheet.Category_Details).forEach(([key, value]) => {
      if (value !== 'NA') {
        textToCopy += `${key.replace(/_/g, ' ')}: ${value}\n`;
      }
    });

    // Add Coverage Details
    textToCopy += '\nCoverage Details:\n';
    textToCopy += `CPT Code: ${white_sheet.Coverage_Details.CPT_Code}\n`;
    textToCopy += `Service Description: ${white_sheet.Coverage_Details.Service_Description}\n`;

    // Add Information Details
    textToCopy += '\nCoverage Information:\n';
    Object.entries(white_sheet.Coverage_Details.Information).forEach(([key, value]) => {
      textToCopy += `${key.replace(/_/g, ' ')}: ${value}\n`;
    });

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopyTooltipOpen(true);
        setTimeout(() => {
          setCopyTooltipOpen(false);
        }, 2000);
      })
      .catch((err) => console.error('Failed to copy: ', err));
  };

  return (
    <Space
      direction="vertical"
      className="call-summary-copay-wrapper"
      style={{
        background: currentTheme.callhistory.searchBackground,
        color: themeMode === "dark" ? "white" : "black",
        minHeight: viewMore ? "75vh" : "fit-content",
        overflow: "hidden",
        width: "100%",
        padding: "16px",
      }}
    >
      <div style={{ height: "100%" }}>
        <Flex justify="space-between" align="center" style={{ marginBottom: "16px" }}>
          <Flex align="center" gap={8}>
            <Text
              style={{
                color: themeMode === "dark" ? "white" : "black",
                fontSize: 19,
              }}
            >
              Call Summary
            </Text>

            {copay_verified === "True" && (
              <Flex align="center">
                <img
                  src="/icons/verified.svg"
                  width={"28rem"}
                  height={"28rem"}
                  title="Human verifed"
                />
                <span style={{ marginLeft: ".5rem", fontSize: "14px" }}>
                  Human Verified
                </span>
              </Flex>
            )}
          </Flex>

          {white_sheet && white_sheet !== "None" && (
            <Flex align="center" gap={12}>
              <Tooltip
                title="Copied"
                open={copyTooltipOpen}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                onClose={() => setCopyTooltipOpen(false)}
              >
                <IconButton sx={{ p: 0 }} onClick={handleCopyToClipboard}>
                  <ContentCopyIcon
                    style={{
                      color: themeMode === "dark" ? "white" : "black",
                    }}
                  />
                </IconButton>
              </Tooltip>
              <IconButton sx={{ p: 0 }} onClick={handleDownloadPDF}>
                <img
                  src={
                    themeMode === "dark"
                      ? "/icons/dark-theme/pdf-download.png"
                      : "/icons/light-theme/pdf-download.png"
                  }
                  height={"30vh"}
                  alt="Download PDF"
                />
              </IconButton>
              <IconButton sx={{ p: 0 }} onClick={handleDownload}>
                <img
                  src={
                    themeMode === "dark"
                      ? "/icons/dark-theme/excel-download.png"
                      : "/icons/light-theme/excel-download.png"
                  }
                  height={"30vh"}
                  alt="Download Excel"
                />
              </IconButton>
              <Text
                onClick={() => setViewMore(!viewMore)}
                style={{
                  color: themeMode === "dark" ? "white" : "black",
                  textDecoration: "underline",
                  fontSize: "13px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                {!viewMore ? "View More" : "View Less"}
              </Text>
            </Flex>
          )}
        </Flex>

        {white_sheet && white_sheet !== "None" && (
          <WhiteSheetDetails white_sheet={white_sheet} viewMore={viewMore} />
        )}
      </div>
    </Space>
  );
};

export const MoreCallDetails = () => {
  const { currentTheme, themeMode } = useTheme();
  const [activeTab, setActiveTab] = useState("more-details");
  const { callContent } = useCallHistoryProvider();
  const { overall_call_metadata } = callContent || {};
  const { before_transfer, after_transfer } = overall_call_metadata || {};

  const keys = {
    id: "Conversation ID",
    call_end_time: "End Time Stamp",
    call_start_time: "Start Time Stamp",
    total_talk_time: "Total Duration",
    caller_name: "Caller Name",
  };
  const data = {
    "more-details": before_transfer || {},
    "transfer-details": after_transfer || {},
  };

  const renderKeyValues = ({ key, value }) => {
    const title = keys[key];
    return (
      <Flex justify="space-between" style={{ width: "100%" }}>
        <Text
          style={{
            color: themeMode === "dark" ? "white" : "black",
            fontSize: 13,
            width: "50%",
            paddingLeft: 20,
          }}
        >
          {title}
        </Text>
        <Text
          style={{
            color: themeMode === "dark" ? "white" : "black",
            fontSize: 13,
            width: "20%",
          }}
        >
          :
        </Text>
        <Text
          style={{
            color: themeMode === "dark" ? "white" : "black",
            fontSize: 13,
            width: "30%",
            marginLeft: "auto",
          }}
        >
          {value}
        </Text>
      </Flex>
    );
  };
  return (
    <div style={{ display: "flex", gap: "2vh" }}>
      <Space
        className="call-summary-more-wrapper"
        direction="vertical"
        style={{
          background: currentTheme.callhistory.searchBackground,
          color: themeMode === "dark" ? "white" : "black",
          maxHeight: "30vh",
          height: "40vh",
        }}
      >
        <Flex className="call-summary-more-headers-wrapper">
          <div
            className={`more-details ${
              activeTab === "more-details" ? "active" : ""
            }`}
            onClick={() => setActiveTab("more-details")}
            style={{
              background: currentTheme.callhistory.orange,
            }}
          >
            <Text
              style={{
                color:
                  activeTab === "more-details"
                    ? "#ffffff"
                    : themeMode === "dark"
                    ? "white"
                    : "black",
                fontSize: 13,
              }}
            >
              More Call Details
            </Text>
          </div>
        </Flex>

        <Flex vertical gap={4}>
          {Object.entries(data["more-details"])?.map(([key, value]) => {
            return renderKeyValues({ key, value });
          })}
        </Flex>
      </Space>
      <Space
        className="call-summary-more-wrapper"
        direction="vertical"
        style={{
          background: currentTheme.callhistory.searchBackground,
          color: themeMode === "dark" ? "white" : "black",
          maxHeight: "30vh",
          height: "40vh",
        }}
      >
        <Flex className="call-summary-more-headers-wrapper">
          <div
            className={`transfer-details ${
              activeTab === "transfer-details" ? "active" : ""
            }`}
            onClick={() => setActiveTab("transfer-details")}
            style={{
              background: currentTheme.callhistory.orange,
            }}
          >
            <Text
              style={{
                color:
                  activeTab === "transfer-details"
                    ? "#ffffff"
                    : themeMode === "dark"
                    ? "white"
                    : "black",
                fontSize: 13,
              }}
            >
              Transfer Call Details
            </Text>
          </div>
        </Flex>
        <Flex vertical gap={4}>
          {Object.entries(data["transfer-details"])?.map(([key, value]) => {
            return renderKeyValues({ key, value });
          })}
        </Flex>
      </Space>
    </div>
  );
};

const WhiteSheetDetails = ({ white_sheet, viewMore }) => {
  const { themeMode } = useTheme();
  const isDark = themeMode === "dark";

  const containsPriorApproval = (text) => {
    const priorApprovalTerms = [
      "prior authorization",
      "prior auth",
      "preauthorization",
      "pre authorization",
    ];
    return priorApprovalTerms.some(term => 
      text.toLowerCase().includes(term.toLowerCase())
    );
  };

  const renderKeyValue = (key, value, indent = false) => {
    const isBold = containsPriorApproval(key);
    return (
      <Flex
        key={key}
        justify="space-between"
        style={{
          padding: viewMore ? "8px 16px" : "4px 16px",
          paddingLeft: indent ? "32px" : "16px",
          backgroundColor: isDark 
            ? (isBold ? "rgba(255, 78, 58, 0.1)" : "transparent")
            : (isBold ? "rgba(255, 78, 58, 0.05)" : "transparent"),
          borderRadius: "4px",
          margin: viewMore ? "4px 0" : "2px 0",
        }}
      >
        <Text
          style={{
            color: isBold ? "#ff4e3a" : (isDark ? "white" : "#333"),
            fontSize: viewMore ? 14 : 13,
            width: "60%",
            fontWeight: isBold ? "600" : "normal",
          }}
        >
          {key.replace(/_/g, " ")}
        </Text>
        <Text
          style={{
            color: isBold ? "#ff4e3a" : (isDark ? "white" : "#333"),
            fontSize: viewMore ? 14 : 13,
            width: "40%",
            textAlign: "right",
            fontWeight: isBold ? "600" : "normal",
          }}
        >
          {value === "NA" ? "-" : value}
        </Text>
      </Flex>
    );
  };

  if (!white_sheet) return null;

  const compactFields = [
    { key: "CPT Code", value: white_sheet.Coverage_Details.CPT_Code },
    { key: "Copay", value: white_sheet.Coverage_Details.Information.Copay },
    { key: "Individual deductible", value: white_sheet.Coverage_Details.Information.Individual_deductible },
    { key: "Individual deductible met", value: white_sheet.Coverage_Details.Information.Individual_deductible_met },
    { key: "Coinsurance", value: white_sheet.Coverage_Details.Information.Coinsurance },
    { key: "Prior authorization required for this code", value: white_sheet.Coverage_Details.Information["Prior authorization required for this code"] },
    { key: "Active prior authorization on file", value: white_sheet.Coverage_Details.Information["Active prior authorization on file"] }
  ];

  return (
    <Space
      direction="vertical"
      style={{
        width: "100%",
        backgroundColor: isDark ? "#242243" : "#fff",
        borderRadius: "8px",
        padding: viewMore ? "16px" : "12px",
      }}
    >
      {/* Only show Category Details in view more mode */}
      {viewMore && white_sheet.Category_Details.regular_calls === "Regular call" && (
        <div style={{ marginBottom: "16px" }}>
          <Text
            style={{
              fontSize: 16,
              fontWeight: "600",
              color: isDark ? "#fff" : "#333",
              marginBottom: "8px",
              borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "#eee"}`,
              paddingBottom: "8px",
            }}
          >
            Category Details
          </Text>
          {renderKeyValue("Regular Calls", white_sheet.Category_Details.regular_calls)}
        </div>
      )}

      {/* Coverage Details */}
      <div>
        {viewMore && (
          <Text
            style={{
              fontSize: 16,
              fontWeight: "600",
              color: isDark ? "#fff" : "#333",
              marginBottom: "8px",
              borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "#eee"}`,
              paddingBottom: "8px",
            }}
          >
            Coverage Details
          </Text>
        )}
        
        {!viewMore ? (
          <>
            {compactFields.map(({ key, value }) => 
              renderKeyValue(key, value)
            )}
          </>
        ) : (
          <div style={{ maxHeight: "55vh", overflowY: "auto" }}>
            {renderKeyValue("CPT Code", white_sheet.Coverage_Details.CPT_Code)}
            {renderKeyValue("Service Description", white_sheet.Coverage_Details.Service_Description)}
            {Object.entries(white_sheet.Coverage_Details.Information).map(([key, value]) => 
              renderKeyValue(key, value, true)
            )}
          </div>
        )}
      </div>
    </Space>
  );
};

export { WhiteSheetDetails };
